export default __webpack_public_path__ + "static/media/badge_6_marsh.506befe5.png";